import { type FormEvent, useState } from 'react'
import { Button } from '@/components/base/buttons/button'
import { Input } from '@/components/base/input/input'
import { Logo } from '@/teile/Logo'
import { ApiError } from '../api/client.js'
import { anmelden } from '../api/verwaltung.js'
import { useSitzung } from '../session/SitzungContext.js'

/**
 * Anmeldung an der Verwaltung — nur netable-Konten. Das erste legt die
 * Einrichtung an, weitere ein angemeldetes Konto. Kein Registrierungsformular.
 */
export function Anmelden() {
  const { neuLaden } = useSitzung()
  const [laeuft, setLaeuft] = useState(false)
  const [meldung, setMeldung] = useState<string | null>(null)

  async function absenden(ereignis: FormEvent<HTMLFormElement>) {
    ereignis.preventDefault()
    const formular = new FormData(ereignis.currentTarget)
    setLaeuft(true)
    setMeldung(null)
    try {
      await anmelden(String(formular.get('email') ?? ''), String(formular.get('passwort') ?? ''))
      await neuLaden()
    } catch (fehler) {
      setMeldung(
        fehler instanceof ApiError && fehler.status === 0
          ? fehler.message
          : 'Anmeldung nicht möglich. Bitte E-Mail und Passwort prüfen.',
      )
    } finally {
      setLaeuft(false)
    }
  }

  return (
    <main className="mx-auto flex min-h-screen max-w-sm flex-col justify-center p-8">
      <div className="relative flex flex-col gap-7">
        <Logo className="absolute bottom-full left-1/2 mb-8 w-[23.5rem] max-w-none -translate-x-1/2 [@media(min-height:880px)]:w-[30.5rem]" />
        <form onSubmit={absenden} className="flex flex-col gap-4">
          <Input
            isRequired
            name="email"
            type="email"
            label="E-Mail"
            autoComplete="username"
            size="md"
          />
          <Input
            isRequired
            name="passwort"
            type="password"
            label="Passwort"
            autoComplete="current-password"
            size="md"
          />
          {meldung ? (
            <p role="status" className="rounded-lg bg-error-primary p-3 text-sm text-error-primary">
              {meldung}
            </p>
          ) : null}
          <Button type="submit" size="lg" isLoading={laeuft}>
            Anmelden
          </Button>
        </form>
        <p className="text-xs text-tertiary">
          Verwaltung von netable. Zugänge vergibt netable; ein vergessenes Passwort wird
          zurückgesetzt, nicht wiederhergestellt.
        </p>
      </div>
    </main>
  )
}
